import { render } from "./CreateBoardModal.vue?vue&type=template&id=dceca7a6&scoped=true"
import script from "./CreateBoardModal.vue?vue&type=script&lang=js"
export * from "./CreateBoardModal.vue?vue&type=script&lang=js"

import "./CreateBoardModal.vue?vue&type=style&index=0&id=dceca7a6&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-dceca7a6"

export default script